import { getCompanyRegistry } from "@/lib/company/companyRegistrySingleton";

/** "We now use the new Boona platform — register again" is for the salons whose clients had accounts on
 *  the old platform (the "ru" locale ones, the backend's client_account_notice). Accounts opened to every
 *  salon on 2026-10-27; a salon that never had them has nothing to re-register. */
export function showsPlatformNotice(): boolean {
    return getCompanyRegistry().getSettings()?.client_account_notice === true;
}
